<template>
    <v-btn @click="handleClick">
        {{ $t(label) }}
        <v-icon v-if="icon != '' && icon != null">{{ icon }}</v-icon>
    </v-btn>
</template>

<script>
    export default {
        props: [
            'label',
            'icon'
        ],
        data() {
            return {}
        },
        methods: {
            handleClick() {
                this.$emit('click')
            }
        }
    }
</script>